"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
require("./bootstrap");
var routes_1 = __importDefault(require("./routes"));
var store_1 = require("./store");
var store_2 = __importDefault(require("./store"));
// @ts-ignore
var App_1 = __importDefault(require("./components/App"));
var axios_1 = __importDefault(require("Shared/plugins/axios"));
var keepalive_1 = __importDefault(require("Shared/plugins/keepalive"));
var vue_select_1 = __importDefault(require("vue-select"));
require("vue-select/dist/vue-select.css");
var vue2_smooth_scroll_1 = __importDefault(require("vue2-smooth-scroll"));
var vue2_transitions_1 = __importDefault(require("vue2-transitions"));
var Sentry = __importStar(require("@sentry/vue"));
var vuetify_1 = __importDefault(require("Shared/plugins/vuetify"));
var vue_lazyload_1 = __importDefault(require("vue-lazyload"));
var vue_lodash_1 = __importDefault(require("vue-lodash"));
var lodash_1 = __importDefault(require("lodash"));
var vue2_editor_1 = __importDefault(require("vue2-editor"));
var sanitize_html_1 = __importDefault(require("sanitize-html"));
var i18n_1 = __importDefault(require("Shared/plugins/i18n"));
var vuetify_2 = __importDefault(require("vuetify"));
var checkPermission_1 = require("Public/store/utils/checkPermission");
var moment_1 = __importDefault(require("moment"));
var vue_video_player_1 = __importDefault(require("vue-video-player"));
require("video.js/dist/video-js.css");
var lodash_2 = __importDefault(require("lodash"));
moment_1.default.locale("en");
vue_1.default.component("vue-select", vue_select_1.default);
vue_1.default.prototype.$p = checkPermission_1.checkPermission;
vue_1.default.prototype._ = lodash_2.default;
vue_1.default.use(vuetify_2.default);
vue_1.default.use(vue_video_player_1.default);
var app = new vue_1.default({
    template: "<app/>",
    vuetify: vuetify_1.default,
    router: routes_1.default,
    store: store_2.default,
    i18n: i18n_1.default,
    render: function (h) { return h(App_1.default); },
});
// @ts-ignore
vue_1.default.use(vue2_editor_1.default);
vue_1.default.use(axios_1.default, app);
vue_1.default.use(keepalive_1.default, { url: "/admin/ka" });
vue_1.default.use(vue2_smooth_scroll_1.default);
vue_1.default.use(vue2_transitions_1.default);
vue_1.default.use(vue_lazyload_1.default, {
    loading: "/-/public/img/lazy-image-loader.gif",
});
vue_1.default.use(vue_lodash_1.default, { lodash: lodash_1.default });
vue_1.default.prototype.$sanitize = sanitize_html_1.default;
if (process.env.NODE_ENV === "production") {
    Sentry.init({
        Vue: vue_1.default,
        dsn: process.env.MIX_SENTRY_DSN_VUE,
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(routes_1.default),
                tracePropagationTargets: ["*"],
            }),
        ],
    });
}
store_2.default.dispatch(store_1.INIT).then(function () {
    app.$mount("#lifeprint-public");
}, function (err) {
    console.log(err);
});
